// src/utils/featureFlags.js

/**
 * 機能フラグ名 → 環境変数キー のマッピング
 */
const FEATURE_ENV_MAP = {
  DocumentTypeAll: 'REACT_APP_FEATURE_DOCUMENT_TYPE_ALL',
};

/**
 * 機能フラグが有効かどうかを判定する
 *
 * 判定ルール:
 *   - 環境変数が未設定または空文字 → 無効（デフォルト無効）
 *   - 'true'                      → 有効
 *   - 'false'                     → 無効
 *
 * @param {string} featureName - FEATURE_ENV_MAP に定義されたフラグ名
 * @returns {boolean}
 */
const isFeatureEnabled = (featureName) => {
  const envKey = FEATURE_ENV_MAP[featureName];
  if (!envKey) {
    console.warn(`[featureFlags] Unknown feature flag: ${featureName}`);
    return false;
  }
  const value = process.env[envKey];
  // 未設定・空文字はデフォルト無効
  if (value === undefined || value === '') return false;
  return value === 'true';
};

/**
 * 「すべて」文書種別（DocumentTypeAll）機能フラグが有効かどうかを返す
 *
 * @returns {boolean}
 */
export const isFeatureEnabledDocumentTypeAll = () => isFeatureEnabled('DocumentTypeAll');